import React, { useState, useEffect, useContext, useRef } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import api from "../../services/api";
import axios from "axios";
import { AuthContext } from "../../context/Auth/AuthContext";
import Board from 'react-trello';
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import { useHistory } from 'react-router-dom';
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import { Badge, Tooltip, Typography, Button, TextField, Box, CircularProgress, InputBase, Avatar } from "@material-ui/core";
import { Flag as ResolveIcon, HighlightOff } from "@material-ui/icons";
import CloseTicketModal from "../../components/CloseTicketModal";
import ButtonWithSpinner from "../../components/ButtonWithSpinner";
import { IconButton } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { format, isSameDay, parseISO } from "date-fns";
import { Can } from "../../components/Can";
import { UsersFilter } from "../../components/UsersFilter";
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(0.5), // Reduzido de 1 para 0.5
    width: "100%",
    height: "100vh",
    overflow: "hidden", // Evitar scroll duplo no container principal
    // Garantir que o layout seja consistente independente do conteúdo
    minHeight: "100vh",
    backgroundColor: "transparent",
  },
  kanbanContainer: {
    width: "100%",
    margin: "0 auto",
    overflowX: "auto", // permite rolagem horizontal
    overflowY: "auto", // permite rolagem vertical
    height: "calc(100vh - 280px)", // altura ajustada para ser consistente
    marginTop: theme.spacing(1), // Reduzido de 2 para 1
    flex: 1, // Ocupar o espaço restante
    // Garantir altura mínima
    minHeight: "400px",
    backgroundColor: "transparent",
    // Garantir que o container tenha largura suficiente para todas as lanes
    '&::-webkit-scrollbar': {
      height: '8px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#c1c1c1',
      borderRadius: '4px',
    },
    // Design com borda lateral colorida
    '& .react-trello-board': {
      display: 'flex !important',
      flexDirection: 'row !important',
      flexWrap: 'nowrap !important',
      width: '100% !important',
      padding: '0 !important',
      margin: '0 !important',
      backgroundColor: 'transparent !important',
    },
    '& .react-trello-lane': {
      flexShrink: '0 !important',
      width: '300px !important',
      minWidth: '300px !important',
      maxWidth: '350px !important',
      margin: '0 8px !important',
      backgroundColor: '#ffffff !important',
      borderRadius: '8px !important',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1) !important',
      
      // Adicionar borda nos cards
      '& .react-trello-card': {
        border: '1px solid #dee2e6 !important',
        borderRadius: '6px !important',
        marginBottom: '8px !important',
        backgroundColor: '#ffffff !important',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1) !important',
        transition: 'box-shadow 0.2s ease !important',
        '&:hover': {
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15) !important',
        }
      },
      
      '& .smooth-dnd-container': {
        minHeight: '200px',
        position: 'relative',
        
        '&:empty': {
          '&::after': {
            content: '"Arraste tickets aqui"',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: '#6c757d',
            fontSize: '14px',
            fontStyle: 'italic',
            textAlign: 'center',
            padding: '20px',
            border: '2px dashed #dee2e6',
            borderRadius: '8px',
            backgroundColor: 'transparent',
            width: 'calc(100% - 40px)',
            boxSizing: 'border-box',
            pointerEvents: 'none',
          }
        }
      },
      
      // Header com fundo neutro
      '& header': {
        backgroundColor: 'transparent !important',
        color: '#2c3e50 !important',
        borderRadius: '8px 8px 0 0 !important',
        borderBottom: '1px solid #dee2e6 !important',

        '& span': {
          backgroundColor: 'transparent !important',
          color: '#495057 !important',
        }
      },

      // Garantir que as lanes fiquem lado a lado mesmo em dispositivos móveis
      [theme.breakpoints.down('sm')]: {
        flexShrink: '0 !important',
        flexGrow: '0 !important',
        flexBasis: 'auto !important',
        minWidth: '280px !important',
        maxWidth: '320px !important',
        margin: '0 4px !important',
      },

      [theme.breakpoints.down('xs')]: {
        minWidth: '250px !important',
        maxWidth: '290px !important',
        margin: '0 2px !important',
      }
    }
  },
  connectionTag: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText || "#ffffff",
    marginRight: 1,
    padding: '3px 6px',
    fontWeight: 'bold',
    borderRadius: 4,
    fontSize: "0.65em",
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  userTag: {
    background: 'transparent',
    color: theme.palette.primary.main,
    marginRight: 1,
    padding: '3px 6px',
    fontWeight: 'bold',
    borderRadius: 4,
    fontSize: "0.65em",
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  lastMessageTime: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    marginLeft: "auto",
    color: theme.palette.text.secondary,
  },
  lastMessageTimeUnread: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    color: theme.palette.success.main,
    fontWeight: "bold",
    marginLeft: "auto"
  },
  clickableHeader: {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    padding: '8px 12px',
    borderRadius: '6px 6px 0 0',
    borderBottom: '2px solid',
    fontWeight: 'bold',
    '&:hover': {
      opacity: 0.8,
      transform: 'translateY(-1px)',
    }
  },
  cardButton: {
    marginRight: theme.spacing(1),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  searchIcon: {
    color: theme.palette.primary.main,
    marginLeft: 6,
    marginRight: 6,
    alignSelf: 'center',
  },
  filtersContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '1200px',
    marginBottom: '10px', // Reduzido de 20px para 10px
    padding: theme.spacing(0.5), // Reduzido de 1 para 0.5
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(1),
    },
  },
  topFiltersRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(0.5), // Reduzido de 1 para 0.5
    justifyContent: 'flex-start', // Alterado de space-between para flex-start para agrupar elementos
    gap: theme.spacing(2), // Adicionar gap para espaçamento consistente entre os grupos
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(1),
      flexDirection: 'column',
      alignItems: 'stretch', // Em mobile, esticar para ocupar toda a largura
      justifyContent: 'flex-start', // Em mobile, alinhar ao topo
    },
  },
  bottomFiltersRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    marginTop: theme.spacing(1), // Reduzido de 2 para 1
    flexDirection: 'column', // Sempre em coluna para melhor organização
    alignItems: 'flex-start', // Alinhar à esquerda em vez de centralizar
    gap: theme.spacing(1), // Reduzido de 2 para 1
    [theme.breakpoints.down('md')]: {
      alignItems: 'stretch', // Em mobile, esticar para ocupar toda a largura
      justifyContent: 'flex-start', // Em mobile, alinhar ao topo
    },
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
      marginTop: theme.spacing(1.5),
    },
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '220px',
    marginRight: theme.spacing(1), // Reduzido de 2 para 1
    borderRadius: 40,
    padding: 4,
    backgroundColor: '#f5f5f5',
    border: '1px solid #e0e0e0',
    '&:hover': {
      backgroundColor: '#ffffff',
      boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0,
      marginBottom: theme.spacing(0.5), // Reduzido de 1 para 0.5
    },
  },
  dateInputsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // Alterado para space-between para posicionar o botão à direita
    width: '100%',
    gap: theme.spacing(1), // Reduzido de 2 para 1
    marginBottom: theme.spacing(0.5), // Reduzido de 1 para 0.5
    flexWrap: 'wrap', // Permitir quebra de linha se necessário
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(0.5), // Reduzido de 1 para 0.5
      alignItems: 'flex-start',
      justifyContent: 'flex-start', // Em mobile, alinhar à esquerda
    },
  },
  dateInput: {
    width: 180, // Largura um pouco maior para melhor visualização
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '280px', // Limitar largura máxima em mobile
    },
  },
  filterContainer: {
    width: '200px',
    marginRight: theme.spacing(1), // Reduzido de 2 para 1
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0,
      marginBottom: theme.spacing(0.5), // Reduzido de 1 para 0.5
    },
  },
  rightActions: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  statusToggleContainer: {
    marginRight: theme.spacing(1), // Reduzido de 2 para 1
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0,
      marginBottom: theme.spacing(0.5), // Reduzido de 1 para 0.5
    },
  },
  statusToggle: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    '& .MuiToggleButton-root': {
      textTransform: 'none',
      minWidth: 'auto',
      padding: theme.spacing(0.25, 1), // Reduzido o padding vertical
      height: 32, // Altura menor
      fontSize: '0.8rem', // Fonte menor
    },
    '& .MuiToggleButton-root.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(1), // Reduzido de 2 para 1
    justifyContent: 'flex-start', // Alinhar à esquerda
      width: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start', // Alinhar à esquerda em mobile também
      gap: theme.spacing(0.5), // Reduzido de 1 para 0.5
    },
  },
  searchInput: {
    flex: 1,
    border: 'none',
    borderRadius: 25,
    outline: 'none',
    backgroundColor: 'transparent',
    padding: '0 8px',
  },
  actionButton: {
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      width: '100%', // Em mobile, ocupar toda a largura
      maxWidth: '300px', // Limitar largura máxima para não ficar muito largo
    },
  },
  pendingButton: {
    backgroundColor: '#ffc107 !important',
    color: '#212529 !important',
    textTransform: 'none',
    minWidth: 'auto',
    padding: theme.spacing(0.25, 1), // Reduzido o padding vertical
    height: 32, // Altura menor
    fontSize: '0.8rem', // Fonte menor
    border: '1px solid #dee2e6',
    '&:hover': {
      backgroundColor: '#e0a800 !important',
    },
    '&.Mui-selected': {
      backgroundColor: '#ffc107 !important',
      color: '#212529 !important',
      '&:hover': {
        backgroundColor: '#e0a800 !important',
      },
    },
  },
  dateFiltersContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2), // Adicionar margem inferior para separar dos botões
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0,
      marginBottom: theme.spacing(2),
      flexDirection: 'column', // Em mobile, coluna em vez de linha
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  },
  filterTypeToggle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start', // Alinhar à esquerda
    marginBottom: theme.spacing(0.5), // Reduzido de 1 para 0.5
  },
  filterToggleButton: {
    textTransform: 'none',
    minWidth: 'auto',
    padding: theme.spacing(0.25, 1), // Reduzido o padding vertical
    height: 32, // Altura menor
    fontSize: '0.8rem', // Fonte menor
    border: '1px solid #dee2e6',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  userFilterContainer: {
    display: 'flex',
    alignItems: 'flex-start', // Alinhar ao topo
    justifyContent: 'flex-start', // Alterado de flex-end para flex-start
    marginLeft: 0, // Remover margin-left auto para não empurrar para a direita
    flexDirection: 'column', // Organizar em coluna (filtro acima, botão abaixo)
    gap: theme.spacing(1), // Reduzido de 2 para 1
    minWidth: '120px', // Mesmo tamanho dos botões de filtro (minWidth: 120px)
    maxWidth: '140px', // Mesmo tamanho dos botões de filtro (maxWidth: 140px)
    [theme.breakpoints.down('md')]: {
      marginLeft: 0, // Em mobile, não usar margin-left
      width: '100%',
      minWidth: '100%', // Em mobile, ocupar toda a largura
      maxWidth: '100%', // Em mobile, ocupar toda a largura
      justifyContent: 'flex-start',
      alignItems: 'stretch', // Em mobile, esticar para ocupar toda a largura
    },
  },
  userFilterLabel: {
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
  },
  userFilterContent: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  addColumnButton: {
    whiteSpace: 'nowrap', // Evitar quebra de linha no texto
    padding: theme.spacing(0.75, 2), // Padding mais generoso para melhor aparência
    fontSize: '0.875rem', // Fonte um pouco maior para melhor legibilidade
    minHeight: '40px', // Altura um pouco maior para melhor proporção
    borderRadius: '8px', // Bordas mais arredondadas para aparência moderna
    textTransform: 'none', // Manter texto original sem transformação
    fontWeight: 500, // Peso da fonte um pouco mais destacado
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Sombra sutil para profundidade
    transition: 'all 0.2s ease-in-out', // Transição suave para interações
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)', // Sombra mais pronunciada no hover
      transform: 'translateY(-1px)', // Leve movimento para cima no hover
    },
    '&:disabled': {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[500],
      boxShadow: 'none',
      cursor: 'not-allowed',
      '&:hover': {
        boxShadow: 'none',
        transform: 'none',
      },
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '100%', // Em mobile, ocupar toda a largura disponível
      minWidth: 'auto', // Em mobile, largura mínima automática
      fontSize: '0.8rem', // Fonte um pouco menor em mobile para economizar espaço
      padding: theme.spacing(0.75, 1.5), // Padding ajustado para mobile
      minHeight: '36px', // Altura um pouco menor em mobile
      borderRadius: '6px', // Bordas um pouco menos arredondadas em mobile
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem', // Fonte ainda menor em telas muito pequenas
      padding: theme.spacing(0.5, 1), // Padding mais compacto em telas pequenas
      minHeight: '32px', // Altura mais compacta em telas pequenas
    },
  },
  filterActionButton: {
    whiteSpace: 'nowrap',
    padding: theme.spacing(0.5, 1), // Reduzido de (0.75, 1.5) para (0.5, 1) - mais compacto
    fontSize: '0.8rem', // Reduzido de 0.875rem para 0.8rem - fonte menor
    minHeight: '32px', // Reduzido de 36px para 32px - altura menor, similar aos inputs
    minWidth: '120px', // Largura mínima para manter proporção
    maxWidth: '140px', // Largura máxima para não ficar muito largo
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '120px', // Em mobile, largura máxima menor
    },
  },
  filterButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5), // Espaçamento menor entre os botões
    marginLeft: theme.spacing(1), // Espaçamento à esquerda dos inputs de data
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row', // Em mobile, botões lado a lado
      justifyContent: 'flex-start',
      gap: theme.spacing(1),
      marginLeft: 0, // Em mobile, sem margem à esquerda
    },
  },
  accordionButton: {
    whiteSpace: 'nowrap',
    padding: theme.spacing(0.5, 1),
    fontSize: '0.8rem',
    minHeight: '32px',
    minWidth: 'auto',
    maxWidth: 'auto',
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    border: 'none',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
    },
    '& .MuiButton-startIcon': {
      transition: 'transform 0.2s ease-in-out',
      marginRight: theme.spacing(0.5),
    },
    '&.expanded .MuiButton-startIcon': {
      transform: 'rotate(180deg)',
    },
  },
  dateFiltersAccordion: {
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out',
    maxHeight: 0,
    opacity: 0,
    '&.expanded': {
      maxHeight: '300px', // Altura aumentada para incluir as abas de filtro
      opacity: 1,
      marginTop: theme.spacing(1),
    },
  },
}));

// Enum para os status de tickets
const TicketStatus = {
  PENDING: 0,
  OPEN: 1,
  CLOSED: 2,
  ARCHIVED: 3
};

const Kanban = () => {
  const classes = useStyles();
  const theme = useTheme(); // Obter o tema atual
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);

  // Estilos simples para garantir layout horizontal e fundo transparente
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .react-trello-board {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        background-color: transparent !important;
      }
      .react-trello-lane {
        flex-shrink: 0 !important;
        width: 300px !important;
        min-width: 300px !important;
        max-width: 350px !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);
  
  // Debug: verificar valores do usuário
  console.log('DEBUG Kanban - User data:', {
    id: user?.id,
    name: user?.name,
    profile: user?.profile,
    allowColumnManagement: user?.allowColumnManagement,
    isAdmin: user?.profile === 'admin',
    canManageColumns: user?.profile === 'admin' || user?.allowColumnManagement === 'enabled'
  });
  
  const [tags, setTags] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [ticketNot, setTicketNot] = useState(0);
  const [file, setFile] = useState({ lanes: [] });
  const [orphanTickets, setOrphanTickets] = useState([]); // Novo estado para tickets órfãos
  const [startDate, setStartDate] = useState(""); // Data vazia por padrão
  const [endDate, setEndDate] = useState(""); // Data vazia por padrão
  const [filterType, setFilterType] = useState("firstMessage"); // "firstMessage" = primeira mensagem, "lastMessage" = última mensagem
  const [showDateFilters, setShowDateFilters] = useState(false); // Estado para controlar a visibilidade dos filtros de data
  // Verificar se há um status inicial no localStorage
  const getInitialStatus = () => {
    const initialTab = localStorage.getItem('kanbanInitialTab');
    if (initialTab === 'archived') {
      localStorage.removeItem('kanbanInitialTab'); // Limpar após uso
      return TicketStatus.ARCHIVED;
    }
    return TicketStatus.OPEN;
  };
  
  const [selectedStatus, setSelectedStatus] = useState(getInitialStatus);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useState('');
  
  // Estados para o modal de fechamento de tickets
  const [closeTicketModalOpen, setCloseTicketModalOpen] = useState(false);
  const [selectedTicketForClose, setSelectedTicketForClose] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [movingTickets, setMovingTickets] = useState(new Set()); // Tickets em movimento
  const [isPerformingMove, setIsPerformingMove] = useState(false); // Flag para bloquear fetches
  const [pendingTicketsCount, setPendingTicketsCount] = useState(0); // Contador de tickets pendentes
  const [openTicketsCount, setOpenTicketsCount] = useState(0); // Contador de tickets abertos
  const [archivedTicketsCount, setArchivedTicketsCount] = useState(0); // Contador de tickets arquivados
  const [closedTicketsCount, setClosedTicketsCount] = useState(0); // Contador de tickets fechados
  const lastFetchRef = useRef(0);
  const scheduledRef = useRef(null);
  const cancelSourceRef = useRef(null);

  // Filtros globais compartilhados entre todas as abas

  const jsonString = user.queues.map(queue => queue.UserQueue.queueId);

  // Definir usuário atual como padrão se não tiver permissão para gerenciar colunas
  useEffect(() => {
    if (user && user.profile !== 'admin' && user.allowColumnManagement !== 'enabled') {
      // Se não tem permissão, fixar o filtro apenas no usuário atual
      if (selectedUsers.length === 0 || selectedUsers[0]?.id !== user.id) {
        setSelectedUsers([{ id: user.id, name: user.name }]);
      }
    }
  }, [user]);

  useEffect(() => {
    setLoading(true);
    fetchTags();
    fetchAllTicketsCounts(); // Buscar contadores de todos os status
  }, [user, selectedStatus, selectedUsers]);



  const fetchTags = async () => {
    try {
      console.log('DEBUG Kanban - Iniciando fetchTags...');
      const response = await api.get("/tag/kanban/");
      console.log('DEBUG Kanban - Resposta completa da API:', response);
      console.log('DEBUG Kanban - Response.data:', response.data);
      
      const fetchedTags = response.data.lista || [];
      
      console.log('DEBUG Kanban - Tags carregadas:', {
        total: fetchedTags.length,
        tags: fetchedTags.map(tag => ({
          id: tag.id,
          name: tag.name,
          ticketCount: tag.ticketTags?.length || 0
        }))
      });
      
      setTags(fetchedTags);
      fetchTickets();
    } catch (error) {
      console.error('Erro ao carregar tags:', error);
      console.error('Erro completo:', error.response?.data || error.message);
    }
  };

  const fetchAllTicketsCounts = async () => {
    try {
      // Buscar contadores para todos os status
      const statuses = ['pending', 'open', 'archived', 'closed'];
      const countPromises = statuses.map(status => 
        api.get("/ticket/kanban", {
          params: {
            searchParam: '',
            queueIds: JSON.stringify(jsonString),
            showAll: user.profile === 'admin' ? 'true' : 'false',
            profile: user.profile,
            status
          }
        })
      );

      const responses = await Promise.all(countPromises);
      
      setPendingTicketsCount(responses[0]?.data?.count || 0);
      setOpenTicketsCount(responses[1]?.data?.count || 0);
      setArchivedTicketsCount(responses[2]?.data?.count || 0);
      setClosedTicketsCount(responses[3]?.data?.count || 0);

      console.log('DEBUG Kanban - Contadores carregados:', {
        pending: responses[0]?.data?.count || 0,
        open: responses[1]?.data?.count || 0,
        archived: responses[2]?.data?.count || 0,
        closed: responses[3]?.data?.count || 0
      });

    } catch (error) {
      console.error('DEBUG Kanban - Erro ao carregar contadores:', error);
      setPendingTicketsCount(0);
      setOpenTicketsCount(0);
      setArchivedTicketsCount(0);
      setClosedTicketsCount(0);
    }
  };



  const fetchTickets = async () => {
    if (isPerformingMove) {
      console.log('Fetch bloqueado: movimento em progresso');
      return;
    }
    
    try {
      if (cancelSourceRef.current) {
        cancelSourceRef.current.cancel("Cancelando requisição anterior");
      }
      cancelSourceRef.current = axios.CancelToken.source();
      const isClosed = selectedStatus === TicketStatus.CLOSED;
      const isArchived = selectedStatus === TicketStatus.ARCHIVED;
      
      // Determinar o status baseado na seleção
      let status;
      if (isClosed) {
        status = 'closed';
      } else if (isArchived) {
        status = 'archived';
      } else {
        status = 'open';
      }
      
      // Usar os parâmetros corretos para a rota do kanban
      const params = {
        searchParam: searchTerm,
        queueIds: JSON.stringify(jsonString),
        status,
        showAll: user.profile === 'admin' ? 'true' : 'false',
        profile: user.profile,
        filterType: filterType // Usar o estado para controlar o tipo de filtro
      };

      // Só adicionar datas se estiverem preenchidas
      if (startDate && startDate.trim() !== "") {
        params.dateStart = startDate;
      }
      if (endDate && endDate.trim() !== "") {
        params.dateEnd = endDate;
      }

      // Se houver usuários selecionados no filtro, enviar somente IDs
      if (selectedUsers && selectedUsers.length > 0) {
        params.users = JSON.stringify(selectedUsers.map(u => u.id));
      }
      
      console.log('DEBUG Kanban - Usuário:', {
        id: user.id,
        profile: user.profile,
        allTicket: user.allTicket,
        allUserChat: user.allUserChat,
        queues: jsonString,
        selectedStatus: status
      });
      
      console.log('DEBUG Kanban - Parâmetros da requisição:', params);
      
      const { data } = await api.get("/ticket/kanban", {
        params,
        cancelToken: cancelSourceRef.current.token
      }).finally(() => {
        setLoading(false);
        cancelSourceRef.current = null;
      });
      
      console.log('DEBUG Kanban - Resposta da API:', {
        ticketsCount: data?.tickets?.length || 0,
        firstTicket: data?.tickets?.[0],
        hasMore: data?.hasMore,
        count: data?.count,
        status
      });

      if (data && data.tickets) {
        setTickets(data.tickets);
      } else {
        console.log('DEBUG Kanban - Nenhum ticket retornado da API');
        setTickets([]);
      }
    } catch (err) {
      if (axios.isCancel(err)) {
        return;
      }
      console.error('DEBUG Kanban - Erro completo:', err);
      setTickets([]);
    }
  };

  const scheduleFetchTickets = () => {
    const now = Date.now();
    const minInterval = 1500;
    const elapsed = now - lastFetchRef.current;
    if (elapsed >= minInterval) {
      lastFetchRef.current = now;
      fetchTickets();
      return;
    }
    if (!scheduledRef.current) {
      const delay = Math.max(250, minInterval - elapsed);
      scheduledRef.current = setTimeout(() => {
        scheduledRef.current = null;
        lastFetchRef.current = Date.now();
        fetchTickets();
      }, delay);
    }
  };

  const onFiltered = (value) => {
    // Manter objetos { id, name } para exibição no filtro
    setSelectedUsers(value);
  };

  useEffect(() => {
    const companyId = user.companyId;
    const onCompanyTicket = (data) => {
      if (!data) return;
      if (isPerformingMove) {
        console.log('Socket fetch bloqueado: movimento em progresso');
        return;
      }
      if (data.action === "update" || data.action === "delete" || data.action === "removeFromList") {
        scheduleFetchTickets();
      }
    };
    const onCompanyAppMessage = (data) => {
      if (!data) return;
      if (isPerformingMove) {
        return;
      }
      if (data.action === "create" || data.action === "delete") {
        scheduleFetchTickets();
      }
    };
    socket.on(`company-${companyId}-ticket`, onCompanyTicket);
    socket.on(`company-${companyId}-appMessage`, onCompanyAppMessage);

    return () => {
      socket.off(`company-${companyId}-ticket`, onCompanyTicket);
      socket.off(`company-${companyId}-appMessage`, onCompanyAppMessage);
      if (scheduledRef.current) {
        clearTimeout(scheduledRef.current);
        scheduledRef.current = null;
      }
    };
  }, [socket, filterType, isPerformingMove, user.companyId]);

  const handleSearchClick = () => {
    // Validação de datas: data inicial deve ser menor ou igual à data final
    if (startDate && endDate && startDate > endDate) {
      toast.error('A data inicial deve ser menor ou igual à data final!');
      return;
    }
    
    setLoading(true);
    fetchTickets();
  };

  const handleFilterTypeChange = (event, newFilterType) => {
    if (newFilterType !== null) {
      setFilterType(newFilterType);
    }
  };

  const toggleDateFilters = () => {
    setShowDateFilters(!showDateFilters);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleClearFilters = () => {
    // Limpar todos os filtros globais
    setStartDate("");
    setEndDate("");
    setSearchTerm("");
    setFilterType("firstMessage");
    
    // Se não tem permissão para gerenciar colunas, manter o usuário atual no filtro
    if (user.profile !== 'admin' && user.allowColumnManagement !== 'enabled') {
      setSelectedUsers([{ id: user.id, name: user.name }]);
    } else {
      setSelectedUsers([]);
    }
    
    // Buscar tickets com filtros limpos
    fetchTickets();
    toast.info('Filtros limpos!');
  };

  const handleAddColumn = () => {
    history.push('/tagsKanban');
  };

  const handlePendingTicketsClick = () => {
    sessionStorage.setItem('forceTabOpen', 'pending');
    history.push('/tickets');
  };

  const handleClickOpen = (ticket) => {
    setSelectedTicketForClose(ticket);
    setCloseTicketModalOpen(true);
  };

  // Corrigindo a ordem dos parâmetros conforme documentação do react-trello:
  // onCardMoveAcrossLanes(fromLaneId, toLaneId, cardId, index)
  const handleCardMove = async (fromLaneId, toLaneId, cardId, index) => {
    
    // Impedir movimentação para a lane de tickets órfãos
    if (toLaneId === 'orphan-tickets') {
      toast.warning('Não é possível mover tickets para a área de não categorizados!');
      return;
    }

    // Verificar se a tag de destino existe (só para lanes que não são orphan-tickets)
    if (toLaneId !== 'orphan-tickets') {
      const targetTag = tags.find(tag => tag.id.toString() === toLaneId);
      if (!targetTag) {
        console.error('Tag de destino não encontrada:', toLaneId);
        console.log('Tags disponíveis:', tags.map(tag => ({ id: tag.id, name: tag.name })));
        console.log('Comparação:', {
          toLaneId_value: toLaneId,
          toLaneId_type: typeof toLaneId,
          available_ids: tags.map(tag => ({ value: tag.id, type: typeof tag.id, string_version: tag.id.toString() }))
        });
        toast.error(`Erro: Lane de destino não encontrada (ID: ${toLaneId})`);
        return;
      }
    }

    // Se o movimento é dentro da mesma lane, apenas reordenar (não fazer chamadas à API)
    if (fromLaneId === toLaneId) {
      // Apenas atualizar a UI para reordenação dentro da mesma lane
    const updatedLanes = file.lanes.map(lane => {
        if (lane.id === fromLaneId) {
          const cardToMove = lane.cards.find(c => c.id === cardId);
          if (cardToMove) {
            // Remover o card da posição atual e adicionar no final
            const filteredCards = lane.cards.filter(card => card.id !== cardId);
            return {
              ...lane,
              cards: [...filteredCards, cardToMove]
            };
          }
        }
        return lane;
      });
      
      setFile({ lanes: updatedLanes });
      return; // Sair sem fazer chamadas à API
    }

    // Atualização otimista - atualizar a UI imediatamente para movimento entre lanes diferentes
    const updatedLanes = file.lanes.map(lane => {
      if (lane.id === fromLaneId) {
        // Remover o card da lane origem
        return {
          ...lane,
          cards: lane.cards.filter(card => card.id !== cardId)
        };
      } else if (lane.id === toLaneId) {
        // Encontrar o card na estrutura atual
        const cardToMove = file.lanes
          .find(l => l.id === fromLaneId)
          ?.cards.find(c => c.id === cardId);
        
        if (cardToMove) {
          // Adicionar o card na lane destino
          return {
            ...lane,
            cards: [...lane.cards, cardToMove]
          };
        }
      }
      return lane;
    });

        // Atualizar otimisticamente os dados dos tickets também
    const targetTagId = parseInt(toLaneId);
    const updatedTickets = tickets.map(ticket => {
      if (ticket.id.toString() === cardId) {
        // Se está vindo da lane de órfãos, adicionar a nova tag
        if (fromLaneId === 'orphan-tickets') {
          const newTag = tags.find(tag => tag.id === targetTagId);
          if (newTag) {
            return {
              ...ticket,
              tags: [...(ticket.tags || []), newTag]
            };
          }
        } else if (toLaneId !== 'orphan-tickets') {
          // Movimento entre lanes normais: substituir tags Kanban
          const newTag = tags.find(tag => tag.id === targetTagId);
          if (newTag) {
            // Remover tags Kanban existentes e adicionar a nova
            const nonKanbanTags = ticket.tags.filter(tag => 
              !tags.some(kanbanTag => kanbanTag.id === tag.id)
            );
            return {
              ...ticket,
              tags: [...nonKanbanTags, newTag]
            };
          }
        }
      }
      return ticket;
    });
    
    // Atualizar estado dos tickets otimisticamente
    setTickets(updatedTickets);

    // Atualizar a UI imediatamente
    setFile({ lanes: updatedLanes });

    // Marcar ticket como "em movimento" e bloquear fetches
    setMovingTickets(prev => new Set([...prev, cardId]));
    setIsPerformingMove(true);

    try {
      
      // Se está movendo DA lane de órfãos, só adicionar a nova tag (sem remover)
      if (fromLaneId === 'orphan-tickets') {
        console.log('Movendo de órfãos para lane:', toLaneId);
        const response = await api.put(`/ticket-tags/${cardId}/${toLaneId}`);
        console.log('Resposta PUT:', response);
      } else {
        // Fazer apenas o PUT - o backend cuidará de remover a tag antiga
        try {
          const putResponse = await api.put(`/ticket-tags/${cardId}/${toLaneId}`);
        } catch (putError) {
          console.error('Erro no PUT:', putError.response?.data || putError.message);
          throw putError;
        }
      }
      
      // Remover ticket da lista de movimento e liberar fetches
      setMovingTickets(prev => {
        const newSet = new Set(prev);
        newSet.delete(cardId);
        return newSet;
      });
      setIsPerformingMove(false);
      
      toast.success('Ticket movido com sucesso!');
      
      // Fazer um fetch silencioso depois de um delay para sincronizar qualquer mudança perdida
      setTimeout(() => {
        fetchTickets();
      }, 1000);
      
    } catch (err) {
      console.log(err);
      
      // Remover ticket da lista de movimento e liberar fetches
      setMovingTickets(prev => {
        const newSet = new Set(prev);
        newSet.delete(cardId);
        return newSet;
      });
      setIsPerformingMove(false);
      
      // Em caso de erro, reverter a UI e sincronizar
      toast.error('Erro ao mover ticket. Recarregando...');
      await fetchTickets(jsonString);
      popularCards(jsonString);
    }
  };

  const handleLaneMove = async (removedIndex, addedIndex, payload) => {
    
    // Verificar permissão para mover colunas
    if (user.profile !== 'admin' && user.allowColumnManagement !== 'enabled') {
      toast.error('Você não tem permissão para mover colunas!');
      return;
    }
    
    // Verificar se os índices são válidos
    if (removedIndex < 0 || addedIndex < 0 || removedIndex >= file.lanes.length) {
      console.error('Índices inválidos para movimentação de lane');
      return;
    }
    
    // Verificar se a posição realmente mudou
    if (removedIndex === addedIndex) {
      console.log('Lane não foi movida (mesma posição)');
      return;
    }
    
    // Verificar se está tentando mover a lane de órfãos
    if (file.lanes[removedIndex]?.id === 'orphan-tickets') {
      toast.warning('A lane de tickets não categorizados não pode ser movida!');
      return;
    }
    
    // Verificar se está tentando mover para a posição da lane de órfãos
    const targetLane = file.lanes[addedIndex];
    if (targetLane && targetLane.id === 'orphan-tickets') {
      toast.warning('Não é possível mover lanes para esta posição!');
      return;
    }

    
    const lanes = [...file.lanes];
    
    const [removedLane] = lanes.splice(removedIndex, 1);
    lanes.splice(addedIndex, 0, removedLane);
    
    // Atualização otimista da UI
    setFile({ lanes });

    // Filtrar apenas as lanes reais (excluir a lane de órfãos se existir)
    const realLanes = lanes.filter(lane => lane.id !== 'orphan-tickets');
    const newOrderedIds = realLanes.map(lane => Number(lane.id));

    try {
      const response = await api.put('/tag/kanban/order', { orderedIds: newOrderedIds });
      console.log('Resposta do servidor:', response.data);
      toast.success('Ordem das lanes atualizada!');
      
      // Recarregar as tags para garantir que a ordem está atualizada
      await fetchTags();
    } catch (err) {
      console.error('Erro ao atualizar ordem:', err);
      toast.error('Erro ao atualizar ordem das lanes');
      
      // Em caso de erro, reverter a mudança na UI
      await fetchTags();
    }
  };

  const popularCards = async (jsonString) => {    
    console.log('DEBUG Kanban - Iniciando popularCards', {
      ticketsCount: tickets.length,
      selectedStatus,
      tagsCount: tags.length
    });

    const getStatusCondition = (ticket) => {
      const statusMap = {
        [TicketStatus.OPEN]: 'open',
        [TicketStatus.CLOSED]: 'closed',
        [TicketStatus.ARCHIVED]: 'archived'
      };
      
      const expectedStatus = statusMap[selectedStatus];
      const condition = ticket.status === expectedStatus;
      
      console.log('DEBUG Kanban - Status check:', {
        ticketId: ticket.id,
        ticketStatus: ticket.status,
        selectedStatus,
        expectedStatus,
        matches: condition
      });
      
      return condition;
    };

    const laneTagsTickets = tickets.filter(ticket => {
      // Primeiro verifica o status
      if (!getStatusCondition(ticket)) {
        console.log('DEBUG Kanban - Ticket removido por status:', ticket.id);
        return false;
      }

      // Para admin, mostra todos
      if (user.profile === 'admin') return true;

      // Para usuários não-admin:
      let allowed = false;

      // 1. Tickets atribuídos ao usuário
      if (ticket.userId === user.id) {
        allowed = true;
      }
      
      // 2. Tickets sem usuário atribuído (se tiver permissão allTicket)
      if (!ticket.userId && user.allTicket) {
        allowed = true;
      }
      
      // 3. Tickets de outros usuários (se tiver permissão allUserChat)
      if (ticket.userId && user.allUserChat) {
        allowed = true;
      }

      console.log('DEBUG Kanban - Permissão ticket:', {
        ticketId: ticket.id,
        allowed,
        ticketUserId: ticket.userId,
        userAllTicket: user.allTicket,
        userAllUserChat: user.allUserChat
      });

      return allowed;
    });

    console.log('DEBUG Kanban - Tickets após filtros:', {
      originalCount: tickets.length,
      filteredCount: laneTagsTickets.length
    });

    const term = (searchTerm || '').toLowerCase();
    const digitsTerm = term.replace(/\D/g, '');
    const filteredBySearch = term
      ? laneTagsTickets.filter(ticket => {
          const name = (ticket.contact?.name || '').toLowerCase();
          const number = ticket.contact?.number || '';
          const numberDigits = number.replace(/\D/g, '');
          if (digitsTerm.length > 0) {
            return name.includes(term) || numberDigits.includes(digitsTerm);
          }
          return name.includes(term) || number.toLowerCase().includes(term);
        })
      : laneTagsTickets;

    // Helper function to check if a ticket has any Kanban tags
    const hasKanbanTags = (ticket) => {
      if (!ticket.tags || ticket.tags.length === 0) {
        console.log('DEBUG Kanban - Ticket sem tags:', ticket.id);
        return false;
      }
      
      // Check if any of the ticket's tags are Kanban tags
      const hasKanban = ticket.tags.some(tag => tag.kanban === 1);
      
      console.log('DEBUG Kanban - Verificação de tags:', {
        ticketId: ticket.id,
        ticketTags: ticket.tags.map(t => ({ id: t.id, name: t.name, kanban: t.kanban })),
        hasKanban
      });
      
      return hasKanban;
    };

    // Verificar se há tickets sem tags Kanban (tickets órfãos)
    // Excluir tickets que estão sendo movidos para evitar flickering
    const newOrphanTickets = filteredBySearch.filter(ticket => 
      !hasKanbanTags(ticket) && !movingTickets.has(ticket.id.toString())
    );
    
    console.log('DEBUG Kanban - Tickets órfãos:', {
      total: newOrphanTickets.length,
      tickets: newOrphanTickets.map(t => ({
        id: t.id,
        status: t.status,
        tags: t.tags?.map(tag => ({ id: tag.id, name: tag.name }))
      }))
    });
    
    setOrphanTickets(newOrphanTickets);
    
    const lanes = tags.map(tag => {
      const filteredTickets = filteredBySearch.filter(ticket => {
        const tagIds = ticket.tags.map(t => t.id);
        const isInLane = tagIds.includes(tag.id);
        
        if (isInLane) {
          console.log('DEBUG Kanban - Ticket na lane:', {
            ticketId: ticket.id,
            laneId: tag.id,
            laneName: tag.name
          });
        }
        
        return isInLane;
      });

      return {
        id: tag.id.toString(),
        title: tag.name,
        style: { 
          backgroundColor: 'transparent',
          borderLeft: `4px solid ${tag.color}`,
          color: "#2c3e50",
          cursor: user.profile === 'admin' ? 'grab' : 'default'
        },
        laneDraggable: user.profile === 'admin',
        label: filteredTickets?.length.toString(),
        cards: filteredTickets.map(ticket => ({
                      id: ticket.id.toString(),
            label: "Ticket nº " + ticket.id.toString(),
            description: (
              <div style={{ padding: '12px' }}>
                {/* Primeira linha: Número e Botão Resolver */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <span style={{ fontWeight: 'bold', color: '#495057' }}>{ticket.contact.number}</span>
                  {ticket.status === 'archived' && (
                    <ButtonWithSpinner
                      startIcon={<HighlightOff />}
                      onClick={() => handleClickOpen(ticket)}
                      style={{ 
                        color: '#0872b9',
                        fontSize: '12px',
                        textTransform: 'none',
                        padding: '4px 8px',
                        minHeight: '24px'
                      }}
                    >
                      {i18n.t("messagesList.header.buttons.resolve")}
                    </ButtonWithSpinner>
                  )}
                </div>
                
                {/* Segunda linha: Informações de conexão e horário */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '4px',
                    fontSize: '12px',
                    color: '#6c757d'
                  }}>
                    {ticket?.whatsappId && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '11px' }}>WhatsApp:</span>
                        <Badge className={classes.connectionTag}>{ticket.whatsapp?.name.toUpperCase()}</Badge>
                      </div>
                    )}
                    {ticket?.userId && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '11px' }}>Usuário:</span>
                        <Badge className={classes.userTag}>{ticket.user?.name.toUpperCase()}</Badge>
                      </div>
                    )}
                  </div>
                  
                  <Typography
                    className={Number(ticket.unreadMessages) > 0 ? classes.lastMessageTimeUnread : classes.lastMessageTime}
                    component="span"
                    variant="body2"
                    style={{ alignSelf: 'flex-end' }}
                  >
                    {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                      <>{format(parseISO(ticket.updatedAt), "HH:mm")}</>
                    ) : (
                      <>{format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}</>
                    )}
                  </Typography>
                </div>
              </div>
            ),
          title: (
            <div 
              className={classes.clickableHeader}
              style={{ borderBottomColor: tag.color }}
              onClick={() => handleCardClick(ticket.uuid)}
            >
              <Tooltip title={ticket.whatsapp?.name}>
                {IconChannel(ticket.channel)}
              </Tooltip> {ticket.contact.name}
            </div>
          ),
          draggable: true,
          href: "/tickets/" + ticket.uuid,
        })),
      };
    });

    // Se há tickets órfãos, adicionar uma lane especial no início
    if (newOrphanTickets.length > 0) {
      console.log('Adicionando lane de órfãos com', newOrphanTickets.length, 'tickets');
      const orphanLane = {
        id: "orphan-tickets",
        title: `Tickets sem categoria (${newOrphanTickets.length})`,
        style: { 
          backgroundColor: '#fff5f5',
          borderLeft: '4px solid #dc3545',
          color: "#2c3e50",
          cursor: 'default'
        },
        laneDraggable: false,
        cardDraggable: true,
        droppable: false,
        label: newOrphanTickets.length.toString(),
        cards: newOrphanTickets.map(ticket => ({
            id: ticket.id.toString(),
            label: "Ticket nº " + ticket.id.toString(),
            description: (
              <div style={{ padding: '12px' }}>
                {/* Primeira linha: Número e Botão Resolver */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <span style={{ fontWeight: 'bold', color: '#495057' }}>{ticket.contact.number}</span>
                  {ticket.status === 'archived' && (
                    <ButtonWithSpinner
                      startIcon={<HighlightOff />}
                      onClick={() => handleClickOpen(ticket)}
                      style={{ 
                        color: '#0872b9',
                        fontSize: '12px',
                        textTransform: 'none',
                        padding: '4px 8px',
                        minHeight: '24px'
                      }}
                    >
                      {i18n.t("messagesList.header.buttons.resolve")}
                    </ButtonWithSpinner>
                  )}
                </div>
                
                {/* Segunda linha: Informações de conexão e horário */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '4px',
                    fontSize: '12px',
                    color: '#6c757d'
                  }}>
                    {ticket?.whatsappId && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '11px' }}>WhatsApp:</span>
                        <Badge className={classes.connectionTag}>{ticket.whatsapp?.name.toUpperCase()}</Badge>
                      </div>
                    )}
                    {ticket?.userId && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '11px' }}>Usuário:</span>
                        <Badge className={classes.userTag}>{ticket.user?.name.toUpperCase()}</Badge>
                      </div>
                    )}
                  </div>
                  
                  <Typography
                    className={Number(ticket.unreadMessages) > 0 ? classes.lastMessageTimeUnread : classes.lastMessageTime}
                    component="span"
                    variant="body2"
                    style={{ alignSelf: 'flex-end' }}
                  >
                    {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                      <>{format(parseISO(ticket.updatedAt), "HH:mm")}</>
                    ) : (
                      <>{format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}</>
                    )}
                  </Typography>
                </div>
              </div>
            ),
            title: (
              <div 
                className={classes.clickableHeader}
                style={{ borderBottomColor: '#dc3545' }}
                onClick={() => handleCardClick(ticket.uuid)}
              >
                <Tooltip title={ticket.whatsapp?.name}>
                  {IconChannel(ticket.channel)}
                </Tooltip> {ticket.contact.name}
              </div>
            ),
            draggable: true,
            href: "/tickets/" + ticket.uuid,
          })),
      };

      lanes.unshift(orphanLane);
    }
    
    // Log para detectar mudanças no estado das lanes
    const previousLanes = file.lanes;

    setFile({ lanes });
  };

  const handleCardClick = (uuid) => {
    history.push('/tickets/' + uuid);
  };

  // Debounce para popularCards para evitar rerenderizações excessivas
  useEffect(() => {
    const timeoutId = setTimeout(() => {
    popularCards(jsonString);
    }, isPerformingMove ? 0 : 50); // Sem delay durante movimento, pequeno delay caso contrário

    return () => clearTimeout(timeoutId);
  }, [tags, tickets, selectedStatus, movingTickets, isPerformingMove]);

  const handleAddConnectionClick = () => {
    history.push('/tagsKanban');
  };

  // Função removida - duplicada

  const IconChannel = (channel) => {
    switch (channel) {
      case "facebook":
        return <Facebook style={{ color: "#3b5998", verticalAlign: "middle", fontSize: "16px" }} />;
      case "instagram":
        return <Instagram style={{ color: "#e1306c", verticalAlign: "middle", fontSize: "16px" }} />;
      case "whatsapp":
        return <WhatsApp style={{ color: "#25d366", verticalAlign: "middle", fontSize: "16px" }} />
      default:
        return "error";
    }
  };

  const handleStatusChange = (event, newValue) => {
    if (newValue !== null && newValue !== "pending") {
      // Trocar para o novo status (filtros são mantidos globalmente)
      setSelectedStatus(newValue);
    }
  };

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase().trim();
    setSearchTerm(searchedTerm);
  };

  useEffect(() => {
    const id = setTimeout(() => {
      fetchTickets();
    }, 600);
    return () => clearTimeout(id);
  }, [searchTerm]);

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.filtersContainer}>
        <div className={classes.searchContainer}>
          <div className={classes.topFiltersRow}>
            <div className={classes.inputWrapper}>
              <SearchIcon className={classes.searchIcon} />
              <InputBase
                placeholder={i18n.t('Buscar por nome ou número')}
                type='search'
                onChange={handleSearch}
                value={searchTerm}
                className={classes.searchInput}
              />
            </div>

            <div className={classes.statusToggleContainer}>
              <ToggleButtonGroup
                value={selectedStatus}
                exclusive
                onChange={handleStatusChange}
                aria-label="ticket status filter"
                className={classes.statusToggle}
                size="small"
              >
                <ToggleButton 
                  value="pending" 
                  onClick={handlePendingTicketsClick}
                  className={classes.pendingButton}
                >
                  <Badge badgeContent={pendingTicketsCount} color="error" max={9999}>
                    Pendentes
                  </Badge>
                </ToggleButton>
                                 <ToggleButton value={TicketStatus.OPEN}>
                   <Badge badgeContent={openTicketsCount} color="error" max={9999}>
                     {i18n.t("tickets.tabs.open.title")}
                   </Badge>
                 </ToggleButton>
                 <ToggleButton value={TicketStatus.ARCHIVED}>
                   <Badge badgeContent={archivedTicketsCount} color="error" max={9999}>
                     {i18n.t("tickets.search.filterConectionsOptions.archived")}
                   </Badge>
                 </ToggleButton>
                 <ToggleButton value={TicketStatus.CLOSED}>
                   <Badge badgeContent={closedTicketsCount} color="error" max={9999}>
                     {i18n.t("tickets.tabs.closed.title")}
                   </Badge>
                 </ToggleButton>
              </ToggleButtonGroup>
            </div>

             {/* Filtro por usuários movido para o lado direito superior */}
             <div className={classes.userFilterContainer}>
            {(user.profile === 'admin' || user.allowColumnManagement === 'enabled') ? (
                <UsersFilter onFiltered={onFiltered} initialUsers={selectedUsers} />
            ) : (
                // Usuário fixo quando não tem permissão
                <Box style={{ padding: "2px 10px" }}>
                  <TextField
                    variant="outlined"
                    value={user.name}
                    disabled
                    size="medium"
                    style={{
                      marginBottom: "4px",
                      minWidth: "250px",
                      width: "100%"
                    }}
                    InputProps={{
                      style: {
                        fontSize: "14px",
                        padding: "8px 12px",
                        backgroundColor: "#f5f5f5"
                      }
                    }}
                    placeholder="Usuário Atual (Fixo)"
                  />
                </Box>
            )}
               
               {/* Botão de adicionar colunas removido daqui - movido para linha dos filtros */}
             </div>
          </div>

          <div className={classes.bottomFiltersRow}>
             {/* Botão do acordeão para expandir/contrair filtros de data */}
             <div style={{ marginBottom: theme.spacing(1) }}>
               <Button
                 variant="text"
                 onClick={toggleDateFilters}
                 className={`${classes.accordionButton} ${showDateFilters ? 'expanded' : ''}`}
                 startIcon={<ExpandMoreIcon />}
               >
                 Filtro de data
               </Button>
             </div>

             {/* Filtros de data com animação de acordeão */}
             <div className={`${classes.dateFiltersAccordion} ${showDateFilters ? 'expanded' : ''}`}>
               {/* Abas de tipo de filtro (Primeira/Última mensagem) */}
               <div className={classes.filterTypeToggle}>
                 <ToggleButtonGroup
                   value={filterType}
                   exclusive
                   onChange={handleFilterTypeChange}
                   size="small"
                 >
                   <ToggleButton value="firstMessage" className={classes.filterToggleButton}>
                     Primeira Mensagem
                   </ToggleButton>
                   <ToggleButton value="lastMessage" className={classes.filterToggleButton}>
                     Última Mensagem
                   </ToggleButton>
                 </ToggleButtonGroup>
               </div>

               {/* Inputs de data e botões de filtro */}
               <div className={classes.dateInputsContainer}>
                 <TextField
                   label="De"
                   type="date"
                   value={startDate}
                   onChange={handleStartDateChange}
                   className={classes.dateInput}
                   InputLabelProps={{
                     shrink: true,
                   }}
                   inputProps={{
                     max: endDate || undefined, // Data inicial não pode ser maior que a final
                   }}
                 />
                 <TextField
                   label="Até"
                   type="date"
                   value={endDate}
                   onChange={handleEndDateChange}
                   className={classes.dateInput}
                   InputLabelProps={{
                     shrink: true,
                   }}
                   inputProps={{
                     min: startDate || undefined, // Data final não pode ser menor que a inicial
                   }}
                 />
                 
                 {/* Botões de filtro um acima do outro, sem ícones */}
                 <div className={classes.filterButtonsContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearchClick}
                     className={classes.filterActionButton}
              >
                     Aplicar
              </Button>
                   <Button
                     variant="outlined"
                     color="secondary"
                     onClick={handleClearFilters}
                     className={classes.filterActionButton}
                   >
                     Limpar
                   </Button>
                 </div>
               </div>
             </div>
          </div>

          {/* Botão ADICIONAR COLUNAS - só aparece se tiver permissão */}
          {(user.profile === 'admin' || user.allowColumnManagement === 'enabled') && (
            <div className={classes.buttonRow}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddColumn}
                className={classes.addColumnButton}
                startIcon={<AddIcon />}
              >
                ADICIONAR COLUNAS
              </Button>
            </div>
          )}
        </div>
      </div>

      {/* {orphanTickets.length > 0 && (
        <div style={{ 
          backgroundColor: '#ffeaa7', 
          padding: '12px',
          marginBottom: '16px',
          borderRadius: '4px',
          textAlign: 'center',
          fontSize: '14px'
        }}>
          <strong>⚠️ Atenção:</strong> Todos os tickets devem ser categorizados até 31/07/2025
        </div>
      )} */}

      <div className={classes.kanbanContainer}>
          <Board
            data={file}
            draggable={true}
            cardDraggable={true}
            laneDraggable={user.profile === 'admin' || user.allowColumnManagement === 'enabled'}
            onCardMoveAcrossLanes={handleCardMove}
            handleLaneDragEnd={(user.profile === 'admin' || user.allowColumnManagement === 'enabled') ? handleLaneMove : null}
          />
        </div>
        

        
        {/* Modal de Fechamento de Ticket (igual da tela de atendimento) */}
        {selectedTicketForClose && (
          <CloseTicketModal
            modalOpen={closeTicketModalOpen}
            onClose={() => {
              setCloseTicketModalOpen(false);
              setSelectedTicketForClose(null);
            }}
            ticket={selectedTicketForClose}
            action="resolve"
          />
        )}
      </div>
  );
};

export default Kanban;
